import React from 'react';
import { Box } from '@drone-js/core';
import { LazyCartIcon } from 'core/utils/lazyCart';
import { HeaderMobileHamburgerButton, HeaderMobileProps, MenuState, RightHeaderItemsProps } from '@agoda/layout';

export type RightHeaderItemProps = HeaderMobileProps & RightHeaderItemsProps;

export const renderRightHeaderItems = (props: RightHeaderItemProps) => {
    const toggleSideMenu = () => {
        if (props.callbacks.setMenuState) {
            props.callbacks.setMenuState(props.menuState === MenuState.Closed ? MenuState.Open : MenuState.Closed);
        }
    };

    return (
        <Box display="flex" flexDirection="row" justifyContent="center" data-element-name="activities-header-right-items-container">
            {props.isCartIngressEnable && (
                <>
                    <LazyCartIcon headerIconColor={props.headerIconColor || 'secondary'} onCartIconClick={props.callbacks.onRedirectToCartPage} />
                    <Box mx="12" />
                </>
            )}
            <HeaderMobileHamburgerButton
                analytics={props.analytics}
                toggleSideMenu={toggleSideMenu}
                headerIconColor={props.headerIconColor || 'secondary'}
                headerIconVariant={props.headerIconVariant || 'bordered'}
                isShowHamburgerRedDot={props.isShowHamburgerRedDot}
                isOpen={props.menuState === MenuState.Open}
            />
        </Box>
    );
};
